<template>
    <div class="form-group">
        <!-- <div class="row mb-2"> -->
            <label v-if="title && title.trim().length > 0" for="">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
            </label>
            <div class="col-12" v-if="!isReadOnly">
                <div class="form-group">
                  <div class="btn btn-default btn-file" :class="{ 'border-danger': error }">
                    <i class="fas fa-paperclip"></i> Attachment
                    <input type="file" name="attachment" :multiple="isMultiple" @change="onChooseFile">
                  </div>
                  <span class="help-block font-italic ml-2">(Max. {{ maxSize }}MB)</span>
                </div>
            </div>
            <div class="col-12 list-files">
                <div v-if="isMultiple">
                    <div v-for="(file, index) in initialValue" :key="index" class="clearfix mb-1">
                        <span class="text-primary">{{ file.name || file.fileName }} </span> (<span class="text-success">{{ Math.ceil(file.size/1024) }} KB</span>)
                        <a :href="file.fileId ? file.downloadLink : createTempUrl(file)" target="_blank">
                            <i class="fas fa-download text-primary text-bold ml-2" title="Tải file file"></i>
                        </a>
                        <i v-if="!isReadOnly" class="fas fa-times text-danger text-bold ml-2" @click="onRemoveFile(index)" title="Xóa file" style="cursor: pointer"></i>
                    </div>
                </div>
                <div v-if="!isMultiple">
                    <div class="clearfix mb-1" v-if="initialValue && initialValue.length > 0">
                        <span class="text-primary">{{ initialValue[0].name || initialValue[0].fileName }} </span> (<span class="text-success">{{ Math.ceil(initialValue[0].size/1024) }} KB</span>)
                        <a :href="initialValue[0].fileId ? initialValue[0].downloadLink : createTempUrl(initialValue[0])" target="_blank">
                            <i class="fas fa-download text-primary text-bold ml-2" title="Tải file file"></i>
                        </a>
                        <i v-if="!isReadOnly" class="fas fa-times text-danger text-bold ml-2" @click="onRemoveFile(index)" title="Xóa file" style="cursor: pointer"></i>
                    </div>
                </div>
            </div>
        <!-- </div> -->
        <div class="text-danger text-right mb-2" style="margin-top: -13 !important;" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { ref, toRefs } from "vue";
import { mapActions } from 'vuex';
import config from '@/config/prod.env';
export default {
    components: {
        
    },
    name: "TheFilePicker",
    props: {
        title: String,
        initialValue: Array,
        error: String,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isMultiple: Boolean
    },
    data() {
        return {
            API_URL: config.API_URL,
            files: [],
            maxSize: 32, // MB
        }
    },
    setup(props) {
        
    },
    methods: {
        ...mapActions('file', ['downloadFile', 'deleteFile']),

        createTempUrl(file) {
            return URL.createObjectURL(file);
        },

        async onChooseFile(e) {
            if(!this.isMultiple) {
                this.files = [];
            }
            // this.files = this.files.concat(e.target.files)
            for(let i = 0; i < e.target.files.length; i++) {
                this.files.push(e.target.files[i]);
            }
            
            this.emitChange(this.files);
        },
        async onRemoveFile(index) {
            const temp = [];
            for (let i = 0; i < this.files.length; i++) {
                if (index !== i) {
                    temp.push(this.files[i]);
                }/* else {
                    if(this.files[i].id.length > 0) {
                        await this.deleteFile(this.files[i].id);
                    }
                }*/
            }
            this.files = temp;
            
            this.emitChange(this.files);
        },
        emitChange(files) {
            this.$emit('onChange', files);
        },

        // async initialFiles(files) {
        //     // this.files = [];
        //     this.files = files;
        //     // await Promise.all(files.map(async f => {
        //     //     let res = await this.downloadFile(f.id);
        //     //     const file = new File([res], f.fileName, { type: "data:application/octet-stream" });
        //     //     this.files.push({ file: file, base64String: `data:application/octet-stream;base64,${res}`, id: f.id });
        //     // }));
        //     this.emitChange(this.files);
        // },

        // toBase64(file) {
        //     return new Promise((resolve, reject) => {
        //         const reader = new FileReader();
        //         reader.readAsDataURL(file);
        //         reader.onload = () => resolve(reader.result);
        //         reader.onerror = reject;
        //     });
        // }
    },
    mounted() {
        this.files = this.initialValue;
    }
}
</script>